import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';

// Presentational Component
class CategoryWidgetDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.select = this.select.bind(this);
	}

	select(event) {
		this.props.dispatch(push(`/widgets/${this.props.category}/${event.target.value}`));
	}

	render() {
		const { widgets } = this.props;
		const WidgetList = widgets.map((widget, index) =>
			<option key={index}>{widget.name}</option>);
		return (
			<div className='dropdown-container'>
				<select className='dropdown-list' onChange={this.select}>
					{WidgetList}
				</select>
			</div>
		);
	}
}


CategoryWidgetDropdown.propTypes = {
	category: PropTypes.string.isRequired,
	dispatch: PropTypes.func.isRequired,
	widgets: PropTypes.array.isRequired,

};

export default CategoryWidgetDropdown;



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryWidgetDropdown.js